<script>
  import { csrfToken } from '../lib/csrf.js'
  import { notifyNative } from '../lib/native.js'

  let { defaultEmail = '', defaultPassword = '' } = $props()
  let email = $state(defaultEmail)
  let password = $state(defaultPassword)
  let error = $state('')
  let loading = $state(false)

  async function handleSubmit(event) {
    event.preventDefault()
    loading = true
    error = ''

    const response = await fetch('/api/sessions', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-CSRF-Token': csrfToken(),
      },
      body: JSON.stringify({ email, password }),
    })

    if (response.ok) {
      notifyNative("userDidLogin")
      window.location.reload()
    } else {
      const data = await response.json()
      error = data.error || 'Login failed'
    }

    loading = false
  }
</script>

<div class="min-h-screen flex items-center justify-center bg-ground px-4">
  <div class="w-full max-w-sm">
    <h1 class="font-display text-4xl font-semibold text-center mb-8 text-synapse">Loops</h1>

    <form onsubmit={handleSubmit} class="space-y-4">
      {#if error}
        <p class="text-danger text-sm text-center">{error}</p>
      {/if}

      <div>
        <label for="email" class="block text-sm font-medium text-text-muted mb-1">Email</label>
        <input
          id="email"
          type="email"
          bind:value={email}
          required
          class="w-full px-3 py-3 bg-surface-1 border border-border rounded-md text-text focus:ring-2 focus:ring-node focus:border-transparent"
        />
      </div>

      <div>
        <label for="password" class="block text-sm font-medium text-text-muted mb-1">Password</label>
        <input
          id="password"
          type="password"
          bind:value={password}
          required
          class="w-full px-3 py-3 bg-surface-1 border border-border rounded-md text-text focus:ring-2 focus:ring-node focus:border-transparent"
        />
      </div>

      <button
        type="submit"
        disabled={loading}
        class="w-full py-3 px-4 bg-node hover:bg-node-bright text-white font-medium rounded-md transition-colors disabled:opacity-50"
      >
        {loading ? 'Signing in...' : 'Sign in'}
      </button>
    </form>
  </div>
</div>
